import React from 'react';

import { DropDownList } from '@progress/kendo-react-dropdowns';
import { FloatingLabel } from '@progress/kendo-react-labels';

import clsx from 'clsx';

import * as classes from './BobInputField.module.css';

const BobSelectField = ({
    className,
    rounded,
    fillMode,
    id,
    name,
    label,
    onChange,
    onBlur,
    errors,
    touched,
    size,
    value,
    options,
    textField,
    dataItemKey,
    ...props
}) => {

    return (
        <React.Fragment>
            <style>
                {`.k-list-item.k-selected, .k-selected.k-list-optionlabel {
                    color: black;
                  }
                  .k-list-item.k-selected:hover, .k-selected.k-list-optionlabel:hover, .k-list-item.k-selected.k-hover, .k-selected.k-hover.k-list-optionlabel {
                    color: black;
                  }           
                ` }
            </style>
            <FloatingLabel
                className={errors ? classes.ErrorLabel : null}
                label={label}
                editorId={id}
                editorValue={value}
            >
                <DropDownList
                    className={errors ? clsx(classes.Error, className) : clsx(classes.Input, className)}
                    style={{ width: '240px' }}
                    size={size}
                    fillMode={fillMode}
                    rounded={rounded}
                    textField={textField ? textField : null}
                    dataItemKey={dataItemKey ? dataItemKey : null}
                    onBlur={onBlur ? (event) => onBlur(event, name) : null}
                    onChange={(event) => onChange(event, name)}
                    data={options}
                    value={value}
                    name={name}
                />
            </FloatingLabel>
        </React.Fragment>
    );
};

export default BobSelectField;
